import React, {ChangeEvent} from 'react';
import {Box} from '@material-ui/core';
import {EfeFieldText} from 'components';

interface InputValues {
    empty: string;
    input: string;
    filled: string;
    label: string;
}

function FieldText() {
    const label = 'Label';
    const placeholder = 'Placeholder';
    const help = 'Helper Text';

    const [values, setValues] = React.useState<InputValues>({
        empty: '',
        input: '',
        filled: 'Entered text',
        label: label,
    });

    const handleInputChange = (prop: keyof InputValues) =>
        function (event: ChangeEvent<HTMLInputElement>) {
            setValues({...values, [prop]: event.target.value});
        };
    return (
        <Box>
            <Box pt={4}>
                <EfeFieldText
                    id='empty'
                    label={label}
                    placeholder={placeholder}
                    value={values.empty}
                    onChange={handleInputChange('empty')}
                    helperText={help}
                />
            </Box>
            <Box pt={4}>
                <EfeFieldText
                    id='filled'
                    label={label}
                    placeholder={placeholder}
                    value={values.filled}
                    onChange={handleInputChange('filled')}
                    helperText={help}
                />
            </Box>
            <Box pt={4}>
                <EfeFieldText
                    id='filled-foc'
                    label={label}
                    placeholder={placeholder}
                    value={values.filled}
                    onChange={handleInputChange('filled')}
                    helperText={help}
                    autoFocus
                />
            </Box>
            <Box pt={4}>
                <EfeFieldText
                    id='filled-error'
                    label={label}
                    placeholder={placeholder}
                    value={values.empty}
                    onChange={handleInputChange('empty')}
                    helperText={help}
                    error
                />
            </Box>
        </Box>
    );
}

export default FieldText;
